import React, { useEffect, useState } from "react"
import { useParams, useNavigate } from 'react-router-dom'
import api from "../api/config"
import Header from "../partials/header"
import Navbar from "../partials/navbar"
import Footer from "../partials/footer"
function ReceiptData() {
  const { receiptId } = useParams();
  const navigate = useNavigate();
  const [ReceiptData, setReceiptData] = useState(null)
  const [ReceiptAmount, setReceiptAmount] = useState('')
  const [selectedOption, setSelectedOption] = useState('');
  const [imageUrl, setImageUrl] = useState('')
  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  }
  
  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent default form submission behavior

    // Construct the form data
    const formData = {
      receiptId: receiptId,
      amount: ReceiptAmount,
      shop: selectedOption // Add the selected option here
    }
    api.post('/api/amountaction', formData)
      .then(response => {
        console.log('Form submitted successfully', response);
        // Handle successful submission here
      })
      .catch(error => {
        console.error('There was an error submitting the form', error)
        // Handle errors here
      })
      let nxt = +receiptId+1;
      navigate(`/receipt-data/${nxt}`)
  }

  const handleSelectChange = (event) => {
    setReceiptAmount(event.target.value);
}
  useEffect(() => {
    api.get(`/api/receiptinfo/${receiptId}`)
      .then(response => {
        setReceiptData(response.data)
      })
      .catch(error => {
        console.error('Error fetching user data:', error)
      })
  }, [receiptId])

  // Load image with authentication
  useEffect(() => {
    if (ReceiptData && ReceiptData.image) {
      const token = localStorage.getItem('token')
      fetch(`${process.env.REACT_APP_API_BASE_URL || 'https://xmas.westgate.co.ke'}/api/uploads/${ReceiptData.image}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      .then(response => {
        if (!response.ok) throw new Error('Failed to load image')
        return response.blob()
      })
      .then(blob => {
        const url = URL.createObjectURL(blob)
        setImageUrl(url)
      })
      .catch(error => {
        console.error('Error loading image:', error)
        setImageUrl('')
      })
    }
    return () => {
      if (imageUrl) {
        URL.revokeObjectURL(imageUrl)
      }
    }
  }, [ReceiptData])

  if (!ReceiptData) {
    return <div>not found</div>
  }
//console.log(userData)
  return (
<div className="nk-app-root">
  <div className="nk-main ">
  <Header />
    <div className="nk-wrap ">
    <Navbar />
      <div className="nk-content nk-content-fluid">
        <div className="container-xl wide-xl">
          <div className="nk-content-body">
            <div className="nk-block-head nk-block-head-sm">
              <div className="nk-block-between">
                <div className="nk-block-head-content">
                  <h3 className="nk-block-title page-title">{ReceiptData.customer} receipt approval</h3>
                  <div className="nk-block-des text-soft">
                    <p>Receipt information</p>
                  </div>
                </div>
                <div className="nk-block-head-content">
                  <div className="toggle-wrap nk-block-tools-toggle">
                    <a
                      href="#"
                      className="btn btn-icon btn-trigger toggle-expand me-n1"
                      data-target="pageMenu"
                    >
                      <em className="icon ni ni-more-v" />
                    </a>
                    <div
                      className="toggle-expand-content"
                      data-content="pageMenu"
                    >
                      <ul className="nk-block-tools g-3">
                        <li>
                          <div className="drodown">
                            <a
                              href="#"
                              className="dropdown-toggle btn btn-white btn-dim btn-outline-light"
                              data-bs-toggle="dropdown"
                            >
                              <em className="d-none d-sm-inline icon ni ni-calender-date" />
                              <span>
                                <span className="d-none d-md-inline">Last</span>{" "}
                                30 Days
                              </span>
                              <em className="dd-indc icon ni ni-chevron-right" />
                            </a>
                            <div className="dropdown-menu dropdown-menu-end">
                              <ul className="link-list-opt no-bdr">
                                <li>
                                  <a href="#">
                                    <span>Last 30 Days</span>
                                  </a>
                                </li>
                                <li>
                                  <a href="#">
                                    <span>Last 6 Months</span>
                                  </a>
                                </li>
                                <li>
                                  <a href="#">
                                    <span>Last 1 Years</span>
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </li>
                        <li className="nk-block-tools-opt">
                          <a href="/pending-transactions" className="btn btn-primary">
                            <em className="icon ni ni-arrow-left" />
                            <span>Back</span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="nk-block">
              <div className="row g-gs">
                <div className="col-xxl-7">
                  <div className="row g-gs">
                    <div className="col-lg-7 col-xxl-12">
                      <div className="card">
                        <div className="card-inner">
                          <div className="card-title-group align-start mb-2">
                            <div className="card-title">
                              <h6 className="title">Receipt Image</h6>
                              <p>(Raw Image)</p>
                            </div>
                            <div className="card-tools">
                              <em
                                className="card-hint icon ni ni-help-fill"
                                data-bs-toggle="tooltip"
                                data-bs-placement="left"
                                title="Revenue from subscription"
                              />
                            </div>
                          </div>
                          <div className="align-end gy-3 gx-5 flex-wrap flex-md-nowrap flex-lg-wrap flex-xxl-nowrap">
                            <div className="nk-sale-data-group flex-md-nowrap g-4">
                            {imageUrl ? <img src={imageUrl} alt="receipt image" /> : <div>Loading image...</div>}
                            </div>
                           
                          </div>
                        </div>
                      </div>
                    </div>
                    <form onSubmit={handleSubmit}>
  <input type="hidden" value={receiptId} name="receiptId"/>
  <input
    className="form-control form-control-lg" 
    name="amount" 
    required 
    value={ReceiptAmount}
    onChange={handleSelectChange}
  />
  {/* New select input */}
                          <select
                            className="form-control form-control-lg"
                            value={selectedOption}
                            onChange={handleOptionChange}
                          >
                            <option selected hidden value>Select an Option</option>
                            <option value='1'>MANOAH ENTERPRISES  LIMITED (BLOOMING BLOOMS)</option><option value='2'>PAYTECH LIMITED (CAR PARKING OFFICE)</option><option value='3'>GROUND FLOOR</option><option value='4'>ARTCAFFE COFFEE & BAKERY (GRAND)</option><option value='5'>SIR HENRY'S (WESTGATE) LIMITED</option><option value='6'>PRETTY BALLERINAS KENYA LIMITED</option><option value='7'>BATA SHOE KENYA PLC</option><option value='8'>LINTONS PLACE LIMITED</option><option value='9'>FRENCH BEAUTY LIMITED (YVES ROCHER)</option><option value='10'>ERITA E. JEWEL</option><option value='11'>OCEAN BASKET (SIMBISA BRANDS KENYA)</option><option value='12'>TAPAS CEVICHE BAR</option><option value='13'>SWAROVSKI (CRYSTAL SWAN LIMITED)</option><option value='14'>NIKE (ALLIED TRADING EAST AFRICA)</option><option value='15'>FROST CAKERY</option><option value='16'>HEALTHY U TWO THOUSAND LIMITED</option><option value='17'>SAMSUNG (FONES DIRECT LIMITED)</option><option value='18'>RADO (DIAMOND WATCH COMPANY)</option><option value='19'>LACOSTE(HIGH END FASHIONS LIMITED)</option><option value='20'>SONA SHOPPE</option><option value='21'>FRAGRANCE LOUNGE (INSPIRATIONS AFRICA LIMITED)</option><option value='22'>ADIDAS(RA SPORT TRADING KENYA)</option><option value='23'>PUMA(RA SPORTS TRADING LIMITED)</option><option value='24'>HUGO BOSS(FAZAL GROUP KENYA)</option><option value='25'>FAZAL(RAVELLO LIMITED)</option><option value='26'>EDUCATE YOURSELF</option><option value='27'>HOTPOINT APPLIANCES LIMITED</option><option value='28'>LITTLE RED GROUP(NAPOLI GROUP LIMITED)</option><option value='29'>THE GRILL SHACK(SIMBISA BRANDS KENYA LIMITED)</option><option value='30'>CARREFOUR(MAJID AL FUTAIM HYPERMARKETS)</option><option value='31'>GADGET SHOP(MILA INVESTMENTS)</option><option value='32'>PEEKABOO</option><option value='33'>SAFARICOM LIMITED</option><option value='34'>BASIC INTIMATES(PRETTY HEARTS LIMITED)</option><option value='35'>BRANDS(BIG DADDY ENTERPRISES)</option><option value='36'>MOCCA ENTERPRISES LIMITED</option><option value='37'>TREVOR COLLECTION </option><option value='38'>BOSE(HORIZON IMPEX LIMITED)</option><option value='39'>SAMSONITE(SENSATIONS LIMITED)</option><option value='40'>CLARKS(PHIRDOS KENYA LIMITED )</option><option value='41'>GEMESSENCE</option><option value='42'>ARTCAFFE COFFEE & BAKERY LIMITED</option><option value='43'>DTB(DIAMOND TRUST BANK KENYA)</option><option value='44'>MANGO(SPANISH FASHION LIMITED)</option><option value='45'>WESTLANDS FOREX BUREAU EXCHANGE</option><option value='46'>KCB BANK KENYA</option><option value='47'>ARAMEX KENYA LIMITED</option><option value='48'>ABSA BANK KENYA PLC</option><option value='49'>SKETCHERS(PHIRDOS KENYA LIMITED)</option><option value='50'>WOMEN'S SECRET & SPRINGFIELD(ALLIED TRADIND EAST A</option><option value='51'>OPTICA LIMITED</option><option value='52'>MINISO(AMAYA TECHNOLOGY COMPANY)</option><option value='53'>BARISTA(THE DONUT FACTORY)</option><option value='54'>SPORTS PLANET(SENSATIONS LIMITED)</option><option value='55'>BOWLING(WESTGATE SHOPPING MALL)</option><option value='56'>FRAGRANCE GARDEN</option><option value='57'>NZURI SCENTS</option><option value='58'>IKOJN AFRICA LIMITED</option><option value='59'>CRAFT RAINBOW ENTERPRISES</option><option value='60'>ARTWORK FROM AFRICA</option><option value='61'>TAUSI TRENDS</option><option value='62'>BELLA DONA AVANTI</option><option value='63'>SPRING VALLEY COFFEE ROASTERS</option><option value='64'>LIQUOR SHACK(WHITE ANCHOR)</option><option value='65'>SALUTE IWORLD</option><option value='66'>STANBIC BANK KENYA</option><option value='67'>TREVOR COLLECTION</option><option value='68'>AQUAPET & STATIONERS LIMITED</option><option value='69'>BONFIRE ADVETURES AND EVENTS</option><option value='70'>ASHLEY'S KENYA LIMITED</option><option value='71'>WESTGATE CINEMAS</option><option value='72'>HAANDI (TWENTY FOUR CARATS LIMITED)</option><option value='73'>KIDS CORNER</option><option value='74'>SUBWAY(LIBERTY EAGLE KENYA)</option><option value='75'>PIZZA HUT(FEAST LIMITED)</option><option value='76'>KFC(KUKU FOODS LIMITED)</option><option value='77'>SIMBISA BRANDS(CHICKEN INN,PIZZA INN,CREAMY INN)</option><option value='78'>FOOD LIBRARY LIMITED (MESO)</option><option value='79'>WESTGATE SHOPPING MALL (GYM)</option><option value='80'>LORENZO DRY CLEANERS LIMITED</option><option value='81'>Town Team</option>
                          </select>
                          <br></br>
                          <button type="submit" className="btn btn-primary">Submit</button>
</form>

                   
                  </div>
                </div>
            <img></img>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  </div>
</div>
  )
}

export default ReceiptData
